const SEGMENTS = [
  "SCONTO 5%", "SCONTO 10€", "GADGET OMAGGIO", "SCONTO 5%", "+1€ AL GRAMMO", "SCONTO 10%", "SCONTO 5%", "PULIZIA GIOIELLO",
  "SCONTO 10%", "SCONTO 5%", "SCONTO 20€", "GADGET OMAGGIO", "SCONTO 5%", "+1€ AL GRAMMO", "SCONTO 10€", "SCONTO 50€",
];

const SEG_ANGLE = 360 / SEGMENTS.length;
const R = 250;
const C = 265;

function polar(angleDeg, radius) {
  const a = ((angleDeg - 90) * Math.PI) / 180;
  return [C + radius * Math.cos(a), C + radius * Math.sin(a)];
}

function segmentPath(i) {
  const a0 = i * SEG_ANGLE;
  const a1 = a0 + SEG_ANGLE;
  const [x0, y0] = polar(a0, R);
  const [x1, y1] = polar(a1, R);
  return `M ${C} ${C} L ${x0.toFixed(2)} ${y0.toFixed(2)} A ${R} ${R} 0 0 1 ${x1.toFixed(2)} ${y1.toFixed(2)} Z`;
}

export default function MiniWheel() {
  return (
    <div
      className="group relative flex aspect-[4/3] items-center justify-center overflow-hidden bg-[#0a0a0a]"
      data-testid="mini-wheel"
    >
      <div className="gold-spotlight left-1/2 top-1/2 h-[130%] w-[130%] -translate-x-1/2 -translate-y-1/2" />

      {/* riflesso sul pavimento */}
      <div className="absolute bottom-4 left-1/2 h-6 w-[55%] -translate-x-1/2 rounded-[100%] bg-gold/20 blur-2xl transition-all duration-700 group-hover:w-[62%] group-hover:bg-gold/30" />

      {/* ruota 3D laterale, statica */}
      <div
        className="relative w-[74%] max-w-[360px] transition-transform duration-700 ease-out group-hover:-translate-y-1 group-hover:scale-[1.03]"
        style={{ transform: "perspective(1000px) rotateX(16deg) rotateY(-20deg) rotateZ(4deg)" }}
      >
        <div
          className="absolute inset-0 translate-y-3 rounded-full bg-black/70 blur-md"
          aria-hidden="true"
        />
        <svg viewBox={`0 0 ${C * 2} ${C * 2}`} className="relative w-full drop-shadow-[0_25px_40px_rgba(212,175,55,0.22)]">
          <circle cx={C} cy={C} r={R + 8} fill="none" stroke="#D4AF37" strokeWidth="3" />
          <circle cx={C} cy={C} r={R + 14} fill="none" stroke="rgba(212,175,55,0.25)" strokeWidth="1" />
          <g className="spin-slow" style={{ transformOrigin: "265px 265px", animationDuration: "26s" }} data-testid="mini-wheel-rotor">
          {SEGMENTS.map((seg, i) => {
            const isGold = i % 2 === 0;
            const mid = i * SEG_ANGLE + SEG_ANGLE / 2;
            const [tx, ty] = polar(mid, 152);
            const rot = mid > 90 && mid < 270 ? mid + 90 : mid - 90;
            const [dx, dy] = polar(mid, 228);
            return (
              <g key={i}>
                <path
                  d={segmentPath(i)}
                  fill={isGold ? "#D4AF37" : "#0d0d0d"}
                  stroke={isGold ? "#0d0d0d" : "rgba(212,175,55,0.35)"}
                  strokeWidth="1"
                />
                <text
                  x={tx}
                  y={ty}
                  fill={isGold ? "#050505" : seg === "SCONTO 50€" ? "#D4AF37" : "#E8DCC0"}
                  fontSize="12.5"
                  fontFamily="'Playfair Display', serif"
                  fontWeight="600"
                  letterSpacing="1.5"
                  textAnchor="middle"
                  dominantBaseline="middle"
                  transform={`rotate(${rot} ${tx} ${ty})`}
                >
                  {seg}
                </text>
                <circle cx={dx} cy={dy} r="3.5" fill={isGold ? "#050505" : "#D4AF37"} opacity="0.8" />
              </g>
            );
          })}
          </g>
          <circle cx={C} cy={C} r="62" fill="#050505" stroke="#D4AF37" strokeWidth="2" />
          <circle cx={C} cy={C} r="56" fill="none" stroke="rgba(212,175,55,0.25)" strokeWidth="1" />
          <image
            href="/assets/logo-gold.png"
            x={C - 34}
            y={C - 26}
            width="68"
            height="24"
            preserveAspectRatio="xMidYMid meet"
          />
          <text
            x={C}
            y={C + 26}
            textAnchor="middle"
            fill="#D4AF37"
            fontSize="14"
            fontWeight="700"
            fontFamily="Manrope, sans-serif"
            letterSpacing="4"
          >
            GIRA
          </text>
        </svg>
        {/* puntatore */}
        <div className="absolute left-1/2 top-[-4px] z-10 -translate-x-1/2">
          <div className="h-0 w-0 border-x-[11px] border-t-[17px] border-x-transparent border-t-gold drop-shadow-[0_2px_6px_rgba(212,175,55,0.5)]" />
        </div>
      </div>

      {/* invito pubblicitario */}
      <div className="absolute bottom-3 left-1/2 z-10 -translate-x-1/2 whitespace-nowrap border border-gold/50 bg-black/70 px-4 py-2 text-[9px] font-semibold uppercase tracking-[0.3em] text-gold backdrop-blur-sm transition-all duration-500 group-hover:bg-gold group-hover:text-black" data-testid="mini-wheel-cta">
        Tocca la ruota e vinci
      </div>
    </div>
  );
}
